import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const TextShadowBlurListItem = (props) => {
    const { shadowSettingsBlur, updateTextElement, index, maxDropShadowBlur } = props;

    const onShadowBlurChange = (value) => {
        previewHistoryBatch.start();

        updateTextElement(index, {
            shadowSettings: { blur: value }
        });
    };

    return (
        <SliderListItem
            title='Blur'
            value={shadowSettingsBlur}
            displayMultiplier={2}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowBlurChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const shadowSettingsBlur = element && element.shadowSettings ? element.shadowSettings.blur : 0;
    const { maxDropShadowBlur } = state.create.maxValues;

    return {
        shadowSettingsBlur,
        maxDropShadowBlur
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextShadowBlurListItem);
